export default "__VITE_ASSET__99JnOize__"